import React from 'react';
import { Route } from '@reverbdotcom/commons/src/route_settings';
import {
  MY_FAVORITES_WATCH_LIST_ROUTE_PATH,
  MY_FAVORITES_SEARCHES_ROUTE_PATH,
  MY_FAVORITES_SHOPS_ROUTE_PATH,
  MY_FAVORITES_WATCH_LIST_ENDED_ROUTE_PATH,
  MY_FAVORITES_FEED_ROUTE_PATH,
  MY_FAVORITES_DISCOVER_ROUTE_PATH,
  MY_FAVORITES_LANDING_ROUTE_PATH,
  MY_SAVED_LANDING_ROUTE_PATH,
  MY_SAVED_WATCH_LIST_ROUTE_PATH,
  MY_SAVED_WATCH_LIST_ENDED_ROUTE_PATH,
  MY_SAVED_SEARCHES_ROUTE_PATH,
  MY_SAVED_SHOPS_ROUTE_PATH,
  MY_SAVED_FEED_ROUTE_PATH,
  MY_SAVED_DISCOVER_ROUTE_PATH,
} from '../components/shared/constants';
import { buildFavoritesHubPageViewEvent } from '@reverbdotcom/commons/src/event_tracking/favorites';

const favoritesLandingRoute = (key: string, path: string) => (
  <Route
    key={key}
    path={path}
    props={{
      clientSide: false, // Avoid using clientSide: true because it causes stale data after saving a favorite: https://reverb.atlassian.net/browse/HF-407
    }}
    getComponent={(_, cb) => {
      import(
        /* webpackChunkName: 'favorites' */
        '../components/favorites/favorites_layout_wrapper'
      ).then(m => cb(null, m.FavoritesLandingLayoutWrapper));
    }}
  />
);

const favoritesWatchListRoute = (key: string, path: string) => (
  <Route
    key={key}
    path={path}
    props={{
      clientSide: false, // Avoid using clientSide: true because it causes stale data after saving a favorite: https://reverb.atlassian.net/browse/HF-407
      pageViewEvent: ({ location }) => (buildFavoritesHubPageViewEvent(location)),
    }}
    getComponent={(_, cb) => {
      import(
        /* webpackChunkName: 'favorites' */
        '../components/favorites/favorites_layout_wrapper'
      ).then(m => cb(null, m.FavoritesWatchListLayoutWrapper));
    }}
  />
);

const favoritesWatchListEndedRoute = (key: string, path: string) => (
  <Route
    key={key}
    path={path}
    props={{
      ended: true,
      clientSide: false, // Avoid using clientSide: true because it causes stale data after saving a favorite: https://reverb.atlassian.net/browse/HF-407
      pageViewEvent: ({ location }) => (buildFavoritesHubPageViewEvent(location)),
    }}
    getComponent={(_, cb) => {
      import(
        /* webpackChunkName: 'favorites' */
        '../components/favorites/favorites_layout_wrapper'
      ).then(m => cb(null, m.FavoritesWatchListEndedLayoutWrapper));
    }}
  />
);

const favoritesSearchesRoute = (key: string, path: string) => (
  <Route
    key={key}
    path={path}
    props={{
      clientSide: false, // Avoid using clientSide: true because it causes stale data after saving a favorite: https://reverb.atlassian.net/browse/HF-407
      pageViewEvent: ({ location }) => (buildFavoritesHubPageViewEvent(location)),
    }}
    getComponent={(_, cb) => {
      import(
        /* webpackChunkName: 'favorites' */
        '../components/favorites/favorites_layout_wrapper'
      ).then(m => cb(null, m.FavoritesSearchesLayoutWrapper));
    }}
  />
);

const favoritesShopsRoute = (key: string, path: string) => (
  <Route
    key={key}
    path={path}
    props={{
      clientSide: false, // Avoid using clientSide: true because it causes stale data after saving a favorite: https://reverb.atlassian.net/browse/HF-407
      pageViewEvent: ({ location }) => (buildFavoritesHubPageViewEvent(location)),
    }}
    getComponent={(_, cb) => {
      import(
        /* webpackChunkName: 'favorites' */
        '../components/favorites/favorites_layout_wrapper'
      ).then(m => cb(null, m.FavoritesShopsLayoutWrapper));
    }}
  />
);

const favoritesFeedRoute = (key: string, path: string) => (
  <Route
    key={key}
    path={path}
    props={{
      clientSide: true,
      pageViewEvent: ({ location }) => (buildFavoritesHubPageViewEvent(location)),
    }}
    getComponent={(_, cb) => {
      import(
        /* webpackChunkName: 'favorites' */
        '../components/favorites/favorites_layout_wrapper'
      ).then(m => cb(null, m.FavoritesFeedLayoutWrapper));
    }}
  />
);

const favoritesDiscoverRoute = (key: string, path: string) => (
  <Route
    key={key}
    path={path}
    props={{
      clientSide: false,
    }}
    getComponent={(_, cb) => {
      import(
        /* webpackChunkName: 'favorites' */
        '../components/favorites/favorites_layout_wrapper'
      ).then(m => cb(null, m.FavoritesDiscoverWrapper));
    }}
  />
);

export const MyFavoritesLandingRoute = favoritesLandingRoute('my_favorites_landing', MY_FAVORITES_LANDING_ROUTE_PATH);
export const MyFavoritesWatchListRoute = favoritesWatchListRoute('my_favorites_watch_list', MY_FAVORITES_WATCH_LIST_ROUTE_PATH);
export const MyFavoritesWatchListEndedRoute = favoritesWatchListEndedRoute('my_favorites_watch_list_ended', MY_FAVORITES_WATCH_LIST_ENDED_ROUTE_PATH);
export const MyFavoritesSearchesRoute = favoritesSearchesRoute('my_favorites_searches', MY_FAVORITES_SEARCHES_ROUTE_PATH);
export const MyFavoritesShopsRoute = favoritesShopsRoute('my_favorites_shops', MY_FAVORITES_SHOPS_ROUTE_PATH);
export const MyFavoritesFeedRoute = favoritesFeedRoute('my_favorites_feed', MY_FAVORITES_FEED_ROUTE_PATH);
export const MyFavoritesDiscoverRoute = favoritesDiscoverRoute('my_favorites_discover', MY_FAVORITES_DISCOVER_ROUTE_PATH);

export const MySavedLandingRoute = favoritesLandingRoute('my_saved_landing', MY_SAVED_LANDING_ROUTE_PATH);
export const MySavedWatchListRoute = favoritesWatchListRoute('my_saved_watch_list', MY_SAVED_WATCH_LIST_ROUTE_PATH);
export const MySavedWatchListEndedRoute = favoritesWatchListEndedRoute('my_saved_watch_list_ended', MY_SAVED_WATCH_LIST_ENDED_ROUTE_PATH);
export const MySavedSearchesRoute = favoritesSearchesRoute('my_saved_searches', MY_SAVED_SEARCHES_ROUTE_PATH);
export const MySavedShopsRoute = favoritesShopsRoute('my_saved_shops', MY_SAVED_SHOPS_ROUTE_PATH);
export const MySavedFeedRoute = favoritesFeedRoute('my_saved_feed', MY_SAVED_FEED_ROUTE_PATH);
export const MySavedDiscoverRoute = favoritesDiscoverRoute('my_saved_discover', MY_SAVED_DISCOVER_ROUTE_PATH);
